import Vue from 'vue';
import VueRouter from 'vue-router';

import NotFoundPage from '@/views/NotFoundPage/NotFoundPage.vue';
import MotorHome from '@/views/Motor/Home/Home.vue';

Vue.use(VueRouter);

const routes = [
  {
    path: '/',
    redirect: '/motor'
  },
  {
    path: '/motor',
    name: 'MotorHome',
    component: MotorHome,
    meta: {
      layout: 'Motor'
    }
  },
  {
    path: '/motor/offer',
    name: 'MotorOffer',
    component: () => import(/* webpackChunkName: "motor" */ '@/views/Motor/Offer/Offer.vue'),
    meta: {
      layout: 'Motor'
    },
  },
  {
    path: '/motor/send-offer',
    name: 'SendOffer',
    component: () => import(/* webpackChunkName: "send-offer" */ '@/views/Motor/SendOffer/SendOffer.vue'),
    meta: {
      layout: 'Motor'
    }
  },
  {
    path: '/motor/payment',
    name: 'MotorPayment',
    component: () => import(/* webpackChunkName: "motor" */ '@/views/Motor/Payment/Payment.vue'),
    meta: {
      layout: 'Motor'
    }
  },
  {
    path: '/error',
    name: 'ErrorPage',
    component: () => import(/* webpackChunkName: "error" */ '@/views/ComponentsOffer/ErrorPage/ErrorPage.vue'),
    meta: {
      layout: 'Motor'
    }
  },
  {
    path: '/contact',
    name: 'ContactForm',
    component: () => import(/* webpackChunkName: "contact" */ '@/views/ComponentsOffer/ContactForm/ContactForm.vue'),
    meta: {
      layout: 'Motor'
    }
  },
  {
    path: '/promo/:product',
    name: 'PromoCodeForm',
    component: () => import(/* webpackChunkName: "promo" */ '@/views/PromoCode/PromoCode.vue'),
    meta: {
      layout: 'Motor'
    }
  },
  {
    path: '/email-validation/:product',
    name: 'EmailValidationForm',
    component: () => import(/* webpackChunkName: "email-validation" */ '@/views/EmailValidation/EmailValidation.vue'),
    meta: {
      layout: 'Motor'
    }
  },
  {
    // path: '/payment-completion/:id',
    path: '/payment/:id',
    name: 'PaymentCompletion',
    component: () => import(/* webpackChunkName: "payment-completion" */ '@/views/PaymentCompletion/PaymentCompletion.vue'),
    meta: {
      layout: 'Motor'
    }
  },
  {
    path: '*',
    component: NotFoundPage,
    meta: {
      layout: 'Motor',
      requiresAuth: false
    }
  }
];

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  routes,
});

export default router;
